import { createFileRoute, notFound } from '@tanstack/react-router';

import { CategoryPageView } from '@/components/site/pages';
import { buildCategoryJsonLd } from '@/lib/category-json-ld';
import { seoHead } from '@/lib/seo';
import { loadCategoryPage } from '@/server/functions/pages';

export const Route = createFileRoute('/category/$key')({
    loader: async ({ params }) => {
        const data = await loadCategoryPage({ data: params.key });
        if (!data) throw notFound();
        return data;
    },
    head: ({ loaderData }) => {
        const category = loaderData?.category;
        if (!category) {
            return seoHead({
                title: 'מדור לא נמצא',
                description: 'המדור המבוקש לא נמצא.',
                path: '/',
                noIndex: true,
            });
        }

        const description =
            category.description
            || `כל החדשות והכתבות במדור ${category.name} באשקלון - אשקלון ניוז`;

        return seoHead({
            title: `${category.name} באשקלון`,
            description,
            path: `/category/${encodeURIComponent(category.key)}`,
            image: category.pictureUrl || loaderData?.articles?.find((article) => article.cover)?.cover,
            keywords: `${category.name}, אשקלון, חדשות אשקלון, אשקלון ניוז`,
            jsonLd: buildCategoryJsonLd(category, loaderData?.articles ?? []),
        });
    },
    component: CategoryPage,
});

function CategoryPage() {
    const data = Route.useLoaderData();
    return (
        <CategoryPageView
            category={data.category}
            articles={data.articles}
            ads={data.ads}
        />
    );
}
